import * as React from 'react'

const SvgCapIcon = (props) => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 7.33366L13 4.00033L7 0.666992L1 4.00033L7 7.33366ZM7 7.33366L11.1061 5.0525C11.4678 5.96472 11.6667 6.95928 11.6667 8.00029C11.6667 8.46783 11.6266 8.92601 11.5496 9.37156C9.80953 9.54075 8.23269 10.2674 7 11.3707C5.76731 10.2674 4.19047 9.54076 2.45041 9.37156C2.37344 8.92599 2.33333 8.4678 2.33333 8.00024C2.33333 6.95925 2.53216 5.9647 2.89392 5.05249L7 7.33366ZM4.33333 11.3336V6.33366L7 4.85218"
      stroke="#FFAF5F"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgCapIcon
